import { Workbox } from 'workbox-window';

let wb;
if ('serviceWorker' in navigator) {
  // Ensure the path is correct
  wb = new Workbox('/service-worker.js'); // Just use '/service-worker.js'

  wb.addEventListener('controlling', () => {
    window.location.reload();
  });

  // Optional: Listen for updates
  wb.addEventListener('installed', (event) => {
    if (event.isNew) {
      console.log('New service worker installed.');
    }
  });

  wb.register().catch((error) => {
    console.error('Service Worker registration failed:', error);
  });
} else {
  wb = null;
}

export default wb;


// WEBPACK FOOTER //
// ./src/registerServiceWorker.js